import React from 'react';
import PropTypes from 'prop-types';

import EditableSection from '../../components/EditableSection';

import WidthEditor from '../WidthEditor';
import LengthEditor from '../LengthEditor';
import UpliftEditor from '../UpliftEditor';
import FirstHeightOption from '../FirstHeightOption';
import SecondHeightOption from '../SecondHeightOption';
import {useTranslation} from "../../contexts/TranslationContext";
import {ArrowsAltOutlined} from "@ant-design/icons";

const DimensionsEditor = ({ collapsed, translationsData = useTranslation() }) => (
  <EditableSection
    collapsed={collapsed}
    icon={<ArrowsAltOutlined />}
    title={translationsData.garage_dimensions || 'garage_dimensions'}
  >
    <WidthEditor translationsData={translationsData} />
    <LengthEditor translationsData={translationsData} />
    <UpliftEditor translationsData={translationsData} />
    <FirstHeightOption translationsData={translationsData} />
    <SecondHeightOption translationsData={translationsData} />
  </EditableSection>
);

DimensionsEditor.propTypes = {
  collapsed: PropTypes.bool.isRequired
};

export default DimensionsEditor;
